var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"TimerBlock"}},[_vm._v(_vm._s(_vm.pad2(Math.floor(_vm.remainingtime / 60)))+":"+_vm._s(_vm.pad2(_vm.remainingtime % 60)))])}
var staticRenderFns = []

export { render, staticRenderFns }